module.exports = __webpack_public_path__ + "img/hook quantity.c22b6473.png";